import React from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScrollArea from 'react-scrollbar';
import moment from 'moment';
import 'moment-timezone';
import { orderBy as _orderBy, includes as _includes, isEmpty as _isEmpty } from 'lodash';

class VklSalesmanList extends React.Component {
  sortList = key => {
    const { onSort } = this.props;

    if (onSort) {
      onSort(key);
    }
  };

  getSortClass = key => {
    const { sortKey, sortOrder } = this.props;
    return sortKey !== key ? 'sorting' : 'sorting_' + (sortOrder === 'asc' ? 'asc' : 'desc');
  };

  getSortedList = () => {
    const { salesmanList, sortKey, sortOrder } = this.props;

    const list = { ...salesmanList };
    return _orderBy(list, [sortKey], [sortOrder]);
  };

  handleSalesmanClick = salesmanId => {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect(salesmanId);
    }
  };

  render() {
    const {
      intl: { messages },
      user,
      selectedSalesmanList,
    } = this.props;

    const list = this.getSortedList();

    return (
      <ScrollArea
        speed={0.8}
        className=""
        contentClassName=""
        horizontal={false}
        style={{ overflow: 'hidden', height: '445px' }}
      >
        <Table responsive hover condensed class="dataTable">
          <thead>
            <tr>
              <th
                onClick={() => this.sortList('salesman_lastname')}
                class={'hidden-print cursor ' + this.getSortClass('salesman_lastname')}
              >
                {messages.sad.salesman}
              </th>
              <th
                onClick={() => this.sortList('count_businesses')}
                style={{ width: '90px' }}
                class={'text-right cursor ' + this.getSortClass('count_businesses')}
              >
                {messages.sad.offer_short}
              </th>
              <th
                onClick={() => this.sortList('count_orders')}
                style={{ width: '95px' }}
                class={'text-right cursor ' + this.getSortClass('count_orders')}
              >
                {messages.sad.order_short}
              </th>
              <th
                onClick={() => this.sortList('conversion_rate')}
                style={{ width: '80px' }}
                class={'text-right cursor ' + this.getSortClass('conversion_rate')}
              >
                {messages.sad.conversion_rate_short}
              </th>
              <th
                onClick={() => this.sortList('last_business')}
                style={{ width: '150px' }}
                class={'cursor ' + this.getSortClass('last_business')}
              >
                {messages.sad.last_offer_date_short}
              </th>
            </tr>
          </thead>
          <ReactCSSTransitionGroup
            transitionName="tablerows"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1}
            component="tbody"
          >
            {list.map(salesman => {
              const selectedSalesmanStyle = {
                background: _includes(selectedSalesmanList, salesman.salesman_id) ? '#fef6dd' : '',
              };

              return (
                <tr
                  class={_includes(selectedSalesmanList, salesman.salesman_id) ? 'shown' : ''}
                  onClick={() => {
                    this.handleSalesmanClick(salesman.salesman_id);
                  }}
                  key={salesman.salesman_id}
                >
                  <td style={selectedSalesmanStyle} class="hidden-print">
                    {salesman.salesman_lastname}, {salesman.salesman_firstname}
                  </td>
                  <td style={selectedSalesmanStyle} class="text-right">
                    {salesman.count_businesses}
                  </td>
                  <td style={selectedSalesmanStyle} class="text-right">
                    {salesman.count_orders}
                  </td>
                  <td style={selectedSalesmanStyle} class="text-right">
                    {salesman.count_businesses > 0 ? (
                      <FormattedNumber value={salesman.conversion_rate / 100} style="percent" />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td style={selectedSalesmanStyle}>
                    {_isEmpty(salesman.last_business) ? (
                      '-'
                    ) : (
                      <FormattedDate
                        value={new Date(moment.tz(salesman.last_business, 'UTC').tz(user.profile.timezone))}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </ReactCSSTransitionGroup>
        </Table>
      </ScrollArea>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(VklSalesmanList));
